import { createIcon } from '@/components/atoms/Icon';

export default createIcon({
  title: 'Close',
  displayName: 'CloseIcon',
  viewBox: '0 0 20 20',
  path: 'M5.05 13.89a.75.75 0 1 0 1.06 1.06L10 11.06l3.89 3.89a.75.75 0 0 0 1.06-1.06L11.06 10l3.89-3.89a.75.75 0 0 0-1.06-1.06L10 8.94 6.111 5.05a.75.75 0 1 0-1.06 1.06L8.938 10 5.05 13.89Z',
});
